import { AssetGoalData, AssetGoals } from '../type/AssetGoals.type';
import { AssetReport } from '../../assetReport/type/AssetReport.type';
import { getNetAssetTotalAmount } from '../../assetReport/util/AssetStatusCard.util';

export const calculateMonthlyRequiredIncrement = (assetGoals: AssetGoals) => {
  if (!assetGoals) return 0;
  const startYearMonth = new Date(assetGoals.startYearMonth);
  const endYearMonth = new Date(assetGoals.endYearMonth);
  const currentYearMonth = startYearMonth;
  let period = 0;
  while (currentYearMonth < endYearMonth) {
    period = period + 1;
    const nextMonth = currentYearMonth.getMonth() + 1;
    currentYearMonth.setMonth(nextMonth % 12);
    if (nextMonth === 12) {
      currentYearMonth.setFullYear(currentYearMonth.getFullYear() + 1);
    }
  }
  const monthlyReturnRate = assetGoals.annualReturnRate / 100 / 12;
  let monthlyRequiredIncrement =
    ((assetGoals.endAmount - assetGoals.startAmount * Math.pow(1 + monthlyReturnRate, period)) * monthlyReturnRate -
      monthlyReturnRate * Math.pow(1 + monthlyReturnRate, period)) /
    (1 * (Math.pow(1 + monthlyReturnRate, period) - 1));
  if (assetGoals.annualReturnRate === 0) {
    monthlyRequiredIncrement = (assetGoals.endAmount - assetGoals.startAmount) / period;
  }
  return Math.round(monthlyRequiredIncrement);
};

export const getAssetGoalsCardData = (assetGoals: AssetGoals, assetReportList: AssetReport[]) => {
  const result: {
    name: string;
    expected: number;
    actual?: number;
  }[] = [];
  const startYearMonth = new Date(assetGoals.startYearMonth);
  const endYearMonth = new Date(assetGoals.endYearMonth);
  const currentYearMonth = startYearMonth;
  while (currentYearMonth <= endYearMonth) {
    result.push({
      name: `${currentYearMonth.getFullYear()}-${(currentYearMonth.getMonth() + 1).toString().padStart(2, '0')}`,
      expected: assetGoals.startAmount,
    });
    const nextMonth = currentYearMonth.getMonth() + 1;
    currentYearMonth.setMonth(nextMonth % 12);
    if (nextMonth === 12) {
      currentYearMonth.setFullYear(currentYearMonth.getFullYear() + 1);
    }
  }
  const monthlyReturnRate = assetGoals.annualReturnRate / 100 / 12;
  const monthlyRequiredIncrement = calculateMonthlyRequiredIncrement(assetGoals);

  const nextResult: {
    name: string;
    expected: number;
  }[] = [];
  result.forEach((item, index) => {
    nextResult.push({
      name: item.name,
      expected:
        index > 0 ? nextResult[index - 1].expected * (1 + monthlyReturnRate) + monthlyRequiredIncrement : item.expected,
    });
  });
  const achievementRate =
    assetReportList && assetReportList.length > 0
      ? (getNetAssetTotalAmount(assetReportList[0].reportItemList) / assetGoals.endAmount) * 100
      : 0;
  return {
    assetGoals: assetGoals,
    lastNetAssetAmount:
      assetReportList && assetReportList.length > 0 ? getNetAssetTotalAmount(assetReportList[0].reportItemList) : 0,
    achievementRate: achievementRate > 100 ? 100 : achievementRate,
    chartDataList: nextResult.map((item) => {
      const reportItemList = assetReportList.find((assetReport) => assetReport.yearMonth === item.name)?.reportItemList;
      return {
        ...item,
        expected: Math.round(item.expected / 10000) * 10000,
        actual: reportItemList && getNetAssetTotalAmount(reportItemList),
      };
    }),
  } as AssetGoalData;
};
